<template>
  <div>
    <QHloading v-if="QHloading"></QHloading>
    <div class="QHpostionDaohang">
      <div class="box on">
        <span>{{ $getCityFuqin("name") }}排放点接收点分布图</span>
        <div class="flex-center">
          <Input v-model="keyword" placeholder="地址区域(区县镇)" />
          <div class="btn on" @click="getData('other', 300)" style="margin-top: 0">搜一搜</div>
        </div>
        <div style="margin-top: 10px; max-width: 300px">
          <font class="btn" :class="{ on: type == 'other' }" @click="getData('other', 300)">全部分布</font>
          <font class="btn" :class="{ on: type == 'PF100' }" @click="getData('PF100', 200)">排放工地</font>
          <font class="btn" :class="{ on: type == 'JS100' }" @click="getData('JS100', 100)">临时堆放</font>
          <font class="btn" :class="{ on: type == 'JS200' }" @click="getData('JS200', 100)">资源利用</font>
          <font class="btn" :class="{ on: type == 'JS300' }" @click="getData('JS300', 100)">分拣中心</font>
          <font class="btn" :class="{ on: type == 'JS400' }" @click="getData('JS400', 100)">工程回填</font>
          <font class="btn" :class="{ on: type == 'JS500' }" @click="getData('JS500', 100)">装卸码头</font>
          <font class="btn" :class="{ on: type == 'JS600' }" @click="getData('JS600', 100)">跨市处理</font>
          <font class="btn" :class="{ on: type == 'JS700' }" @click="getData('JS700', 100)">移动收集</font>
        </div>
      </div>
    </div>
    <div class="QHzuobiaoMapPage" id="map"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      QHloading: true,
      role: 300,
      type: "other",
      keyword: "",
      map: null,
      maskLayer: null,
    };
  },

  mounted() {
    this.keyword = this.$getUrlParams("keyword") || "";
    this.getData("other", 300);
  },

  methods: {
    //获取地图标记数据
    getData(type, role) {
      this.type = type;
      this.role = role;
      var that = this;
      var https = {
        type: "isApi",
        isLoading: "isLoadingPop",
        api: this.$api.getPaiShouZuobiao,
        parameter: {
          role: this.role,
          keyword: this.keyword,
          type: this.type,
        },
      };
      that.$httpsApi(https, function (res) {
        if (that.map) {
          that.map.destroy();
        }

        //整合坐标数据
        var list = that.getFmtData(res.data);

        //执行地图初始化
        that.mapInit(list);
      });
    },

    //格式化成地图需要的格式数据(坐标)
    getFmtData(data) {
      var that = this;
      var list = [];
      for (var i = 0; i < data.length; i++) {
        var value = data[i];
        var coordinate = that.$commaToarr(value["coordinates"]);
        var obj = {};
        obj["markerId"] = value["markerId"] || "";
        obj["role"] = value["role"] || "";
        obj["name"] = value["name"] || "";
        obj["addressDetailed"] = value["addressDetailed"] || "";
        if (!that.$isblank(coordinate) && coordinate.length == 2) {
          obj["lat"] = parseFloat(coordinate[0]);
          obj["lng"] = parseFloat(coordinate[1]);
          list.push(obj);
        }
      }
      return list;
    },

    // 地图初始化
    async mapInit(list) {
      try {
        // 初始化地图
        this.initializeMap(list);

        // 加载行政区划数据
        const polygons = await this.loadDistrictPolygons();

        // 处理并显示行政区划
        this.processPolygons(polygons);

        // 创建坐标标记点
        this.createMarker(list);

        //关闭加载层
        setTimeout(() => {
          this.QHloading = false;
        }, 500);
      } catch (error) {
        console.error("地图初始化失败:", error);
      }
    },

    // 创建地图标记点
    createMarker(polygon) {
      if (!this.map) {
        console.error("地图未初始化");
        return;
      }

      // 清除旧标记层（如果存在）
      if (this.markerLayer) {
        this.markerLayer.setMap(null);
      }

      // 创建新标记层
      this.markerLayer = new TMap.MultiMarker({
        map: this.map,
        cursor: "pointer",
        zIndex: 100,
        styles: {
          //排放点
          markerPaifang: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/PFD.png"),
            anchor: { x: 16, y: 32 },
          }),
          //排放点
          markerJieshou: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/JSD.png"),
            anchor: { x: 16, y: 32 },
          }),
          //100临时堆放
          markerJieshou100: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/JSD100.png"),
            anchor: { x: 16, y: 32 },
          }),
          //200资源化利
          markerJieshou200: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/JSD200.png"),
            anchor: { x: 16, y: 32 },
          }),
          //300资源利用
          markerJieshou300: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/JSD300.png"),
            anchor: { x: 16, y: 32 },
          }),
          //400工程回填
          markerJieshou300: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/JSD400.png"),
            anchor: { x: 16, y: 32 },
          }),
          //500装卸码头
          markerJieshou400: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/JSD500.png"),
            anchor: { x: 16, y: 32 },
          }),
          //600跨市处理
          markerJieshou500: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/JSD600.png"),
            anchor: { x: 16, y: 32 },
          }),
          //700移动收集箱
          markerJieshou600: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/JSD700.png"),
            anchor: { x: 16, y: 32 },
          }),
        },
        geometries: polygon.map((point) => ({
          position: new TMap.LatLng(point.lat, point.lng),
          styleId: point.markerId,
          properties: {
            markerId: point.markerId,
            role: point.role,
            name: point.name,
            addressDetailed: point.addressDetailed,
          },
        })),
      });

      //初始化infoWindow
      var infoWindow = new TMap.InfoWindow({
        map: this.map,
        enableCustom: true,
        position: new TMap.LatLng(23.126419, 113.234015),
        //设置信息窗相对position偏移像素
        offset: {
          x: 0,
          y: 0,
        },
      });
      infoWindow.close(); //初始关闭信息窗关闭

      // 添加点击事件
      this.markerLayer
        .on("mouseover", (evt) => {
          infoWindow.open(); //打开信息窗
          infoWindow.setPosition(evt.geometry.position); //设置信息窗位置
          var properties = evt.geometry.properties;
          var html1 = '<div class="p1">' + properties.role + "</div>";
          var html2 = '<div class="p2">名称：' + properties.name + "</div>";
          var html3 = '<div class="p3">地址：' + properties.addressDetailed + "</div>";
          var html = '<div class="MultiMarker">' + html1 + html2 + html3 + "</div>";
          infoWindow.setContent(html); //设置信息窗内容
        })
        .on("mouseout", () => {
          infoWindow.close();
        });
    },

    // 初始化地图基础配置
    initializeMap() {
      this.map = new TMap.Map("map", {
        center: new TMap.LatLng(23.126419, 113.234015),
        showLabel: false,
        zoom: 10,
        mapStyleId: "style2",
        showControl: false,
        baseMap: {
          type: "vector",
          features: ["base", "building3d", "label", "building"],
        },
      });
    },

    // 加载行政区划数据
    async loadDistrictPolygons() {
      const district = new TMap.service.District({ polygon: 2 });
      var code = this.$FMTCode(this.$getCityFuqin("code"));
      if (this.$getCityFuqin("level") == 4) {
        var code = this.$FMTCode(this.$getUser("districtCode"));
      };

      const result = await district.search({ keyword: code });
      return new TMap.MultiPolygon({
        map: this.map,
        geometries: [],
      });
    },

    // 处理多边形数据
    processPolygons(polygons) {
      var code = this.$FMTCode(this.$getCityFuqin("code"));
      if (this.$getCityFuqin("level") == 4) {
        var code = this.$FMTCode(this.$getUser("districtCode"));
      };
      new TMap.service.District({ polygon: 2 }).search({ keyword: code }).then((result) => {
        result.result.forEach((level) => {
          level.forEach((place) => {
            // 生成多边形数据
            const geometries = place.polygon.map((polygon, index) => ({
              id: `${place.id}_${index}`,
              paths: polygon,
            }));

            // 更新多边形显示
            polygons.updateGeometries(geometries);

            // 计算并设置地图边界
            const bounds = this.calculateSafeBounds(place.polygon);
            this.map.fitBounds(bounds, { padding: 50 });

            // 创建遮罩层
            this.createMaskLayer(place.polygon);
          });
        });
      });
    },

    // 安全边界计算方法
    calculateSafeBounds(polygons) {
      // 初始化有效边界
      let swLat = 90,
        swLng = 180;
      let neLat = -90,
        neLng = -180;

      polygons.forEach((polygon) => {
        polygon.forEach((point) => {
          const lat = point.lat || point[0];
          const lng = point.lng || point[1];

          swLat = Math.min(swLat, lat);
          swLng = Math.min(swLng, lng);
          neLat = Math.max(neLat, lat);
          neLng = Math.max(neLng, lng);
        });
      });

      return new TMap.LatLngBounds(new TMap.LatLng(swLat, swLng), new TMap.LatLng(neLat, neLng));
    },

    // 创建区域镂空层
    createMaskLayer(targetPolygons) {
      if (this.maskLayer) {
        this.maskLayer.setMap(null);
      }

      // 转换所有多边形坐标并验证方向
      const processPolygon = (polygon) => {
        return polygon;
      };

      // 生成正确方向的外层路径（顺时针）
      var coverage = [new TMap.LatLng(-85, -180), new TMap.LatLng(-85, 180), new TMap.LatLng(85, 180), new TMap.LatLng(85, -180)];

      // 处理多个镂空区域
      const holes = targetPolygons
        .map((polygon) => {
          const validPolygon = processPolygon(polygon);
          if (validPolygon.length < 3) return null;
          return [...validPolygon].reverse(); // 逆时针
        })
        .filter((h) => h !== null);

      // 创建遮罩层
      try {
        this.maskLayer = new TMap.MultiPolygon({
          map: this.map,
          geometries: [
            {
              paths: [coverage, ...holes], // 合并所有路径
              styleId: "maskStyle",
            },
          ],
          styles: {
            maskStyle: new TMap.PolygonStyle({
              color: "rgba(0, 13, 57, 0.6)",
              showBorder: false,
              fillOpacity: 0.1,
              zIndex: 9999, // 设置层级高度，值越大越靠上
            }),
          },
          zIndex: 9999, // 设置层级高度，值越大越靠上
        });

        // 使用备用刷新方法
        setTimeout(() => {
          this.map.setCenter(this.map.getCenter());
          this.maskLayer.setZIndex(9999);
        }, 100);
      } catch (error) {
        console.error("遮罩层创建失败:", error);
      }
    },

    //生成覆盖可视区域的矩形
    createFullCoveragePolygon() {
      // 生成覆盖可视区域的矩形（考虑地图当前投影）
      const bounds = this.map.getBounds();
      return [bounds.getSouthWest(), new TMap.LatLng(bounds.getSouthWest().getLat(), bounds.getNorthEast().getLng()), bounds.getNorthEast(), new TMap.LatLng(bounds.getNorthEast().getLat(), bounds.getSouthWest().getLng())];
    },
  },

  //销毁地图
  beforeDestroy() {
    if (this.map) {
      this.map.destroy();
    }
  },
};
</script>
<style>
html {
  background: radial-gradient(circle, #0c96ff, #092654);
}
.QHpostionDaohang .box {
  padding: 10px;
  font-size: 14px;
}
.QHpostionDaohang span {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
  display: block;
}
.QHpostionDaohang .btn {
  display: inline-block;
  background: #033689;
  height: 36px;
  line-height: 36px;
  padding: 0 5px;
  margin-left: 5px;
  border-radius: 5px;
  color: #fff;
  white-space: nowrap;
  opacity: 0.8;
  margin-top: 10px;
}
.QHpostionDaohang .btn.on {
  opacity: 1;
  background: #f48c0e;
}
</style>
